import Button from 'components/gruenland/atoms/button/Button';
import Input from 'components/gruenland/atoms/input';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';

type Props = {
  email?: string;
  order?: string;
};

const PublicOrderForm: React.FC<Props> = ({ email, order }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    <form method="get" className="pb-10 pt-6">
      <Typography className="text-[16px] text-primary-black md:mb-7 md:text-[24px]">
        {formatMessage({ id: 'publicorder.formTitle', defaultMessage: 'Ricerca ordine' })}
      </Typography>
      <div className="grid gap-3">
        <Input
          defaultValue={email}
          type="email"
          required
          name="email"
          label={formatMessage({ id: 'publicorder.formEmail', defaultMessage: 'Indirizzo email' })}
        />
        <Input
          defaultValue={order}
          type="text"
          required
          name="order"
          label={formatMessage({ id: 'publicorder.formOrder', defaultMessage: 'Codice ordine' })}
        />
      </div>
      <div className="mt-6 grid items-center justify-between gap-8 md:flex md:gap-4">
        <Button type="submit" className="h-10 w-[112px] p-0 text-[14px]">
          {formatMessage({ id: 'publicorder.formSubmit', defaultMessage: 'Ricerca' })}
        </Button>
      </div>
    </form>
  );
};

export default PublicOrderForm;
